import { AxiosInstance } from 'axios'
import { ISessionActivity, SessionActivityType } from '../../../types/sessionActivity.types'

export interface ICreateQuestionPublishedActivityBody {
  type: SessionActivityType.QUESTION_PUBLISHED
  messageId: string
  metadata: {
    questionId: string
    questionTitle: string
  }
}

export type ICreateSessionActivityBody = ICreateQuestionPublishedActivityBody

export function sessionActivitiesApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/knowledge-engine-agent/sessions'
  return {
    createSessionActivity(sessionId: string, body: ICreateSessionActivityBody) {
      return api.post<ISessionActivity>(`${baseUrl}/${sessionId}/activities`, body)
    },
    getSessionActivities(sessionId: string) {
      return api.get<ISessionActivity[]>(`${baseUrl}/${sessionId}/activities`)
    }
  }
}
